import { defineMessages } from 'react-intl';

export const messages: {
	discoverMoreExamples: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	useCasesFilterTrigger: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	useCasesFilterTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	rolesFilterTrigger: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	rolesFilterTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	connectorsFilterTrigger: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	connectorsFilterTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	resultsCount: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	clearFilters: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	clearAll: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	openDropdown: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	discoverMoreExamples: {
		id: 'rovo-conversation-actions.examples.discover-more-examples',
		defaultMessage: 'Discover more examples',
		description: 'Header text for the more examples section',
	},
	useCasesFilterTrigger: {
		id: 'rovo-conversation-actions.filters.use-cases-trigger',
		defaultMessage: 'Use cases',
		description: 'Trigger text for the use cases filter dropdown',
	},
	useCasesFilterTitle: {
		id: 'rovo-conversation-actions.filters.use-cases-title',
		defaultMessage: 'Filter by use cases',
		description: 'Title for the use cases filter dropdown',
	},
	rolesFilterTrigger: {
		id: 'rovo-conversation-actions.filters.roles-trigger',
		defaultMessage: 'Roles',
		description: 'Trigger text for the roles filter dropdown',
	},
	rolesFilterTitle: {
		id: 'rovo-conversation-actions.filters.roles-title',
		defaultMessage: 'Filter by roles',
		description: 'Title for the roles filter dropdown',
	},
	connectorsFilterTrigger: {
		id: 'rovo-conversation-actions.filters.connectors-trigger',
		defaultMessage: 'Connectors',
		description: 'Trigger text for the connectors filter dropdown',
	},
	connectorsFilterTitle: {
		id: 'rovo-conversation-actions.filters.connectors-title',
		defaultMessage: 'Filter by connectors',
		description: 'Title for the connectors filter dropdown',
	},
	resultsCount: {
		id: 'rovo-conversation-actions.results.count',
		defaultMessage: '{count, plural, one {# result} other {# results}}',
		description: 'Results count text with proper pluralization',
	},
	clearFilters: {
		id: 'rovo-conversation-actions.filters.clear-filters',
		defaultMessage: 'Clear filters',
		description: 'Button text to clear all applied filters',
	},
	clearAll: {
		id: 'rovo-conversation-actions.filters.clear-all',
		defaultMessage: 'Clear all',
		description: 'Button text to clear all applied filters',
	},
	openDropdown: {
		id: 'rovo-conversation-actions.filters.open-dropdown',
		defaultMessage: 'Open dropdown',
		description: 'Accessible label for the chevron icon next to the filter button',
	},
});
